<template>
  <div>
    <v-container>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog v-model="sendLinkDialog" max-width="600">
            <template v-slot:default="sendLinkDialog">
              <v-card>
                <v-toolbar dark color="primary">
                  <v-toolbar-title> Online Admission</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn icon dark @click="sendLinkDialog.value = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-chip class="ma-1" color="gray">
                        Opted Class : <v-chip class="ma-2" color="gray"> {{ selectedclassName }} </v-chip></v-chip
                      >
                    </v-col>
                    <v-col>
                      <span class="body-2 font-weight-medium"> Select Section <span class="error--text">*</span> </span>
                      <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="sectionID" required item-text="name" item-value="id" :items="sections" key="id"> </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn color="primary" :disabled="hasClicked" @click.prevent="sendAdmissionLink()">
                    Send Admission Form Link To Parent
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog v-model="sendLinkDialogOffline" max-width="650">
            <template v-slot:default="sendLinkDialogOffline">
              <v-card>
                <v-toolbar dark color="purple">
                  <v-toolbar-title> Offline Admission</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn icon dark @click="sendLinkDialogOffline.value = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-chip class="ma-1" color="gray">
                        Opted Class : <v-chip class="ma-2" color="gray"> {{ selectedclassName }} </v-chip></v-chip
                      > </v-col
                    ><v-col>
                      <span class="body-2 font-weight-medium"> Select Section <span class="error--text">*</span> </span>
                      <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="sectionID" required item-text="name" item-value="id" :items="sections" key="id"> </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn color="purple" :disabled="hasClicked" @click.prevent="sendAdmissionLink(true)">
                    Pay Now
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <component :is="isCompo" :enquiryID="enquiryIDD" :STUDENT_DATA="STUDENT_DATA"> </component>
    </v-container>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Application List">
        <form @submit.prevent="getRegistration">
          <div class="columns">
            <div class="column is-4">
              <label class="label">From </label>
              <div class="control">
                <input class="input" type="date" :max="filter.toDate" v-model="filter.fromDate" required />
              </div>
            </div>
            <div class="column is-4">
              <label class="label">To </label>
              <div class="control">
                <input class="input" type="date" :max="maxToDate" v-model="filter.toDate" required />
              </div>
            </div>
            <div class="column is-4">
              <label class="label">Action</label>
              <button class="button is-success m-r-10" type="submit">Apply</button>
              <b-button @click="generateCSVData()" type="is-primary" icon-left="briefcase-download" v-show="total > 0">Download CSV </b-button>
            </div>
          </div>
        </form>

        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          />
        </v-card-text>
        <v-divider class=" my-0 " />
        <v-data-table sort-by hide-default-footer :items-per-page="-1" :headers="headers" :items="enquiryData" :search="search" item-key="index">
          <template v-slot:item.actions="{ item }" v-if="isWrite">
            <v-row justify="end">
              <v-col>
                <v-btn x-small class="px-2 ml-1 ma-1" color="red" outlined @click.prevent="viewDocuments(item.enquiry.enquiryCode)">
                  View Docs
                </v-btn>

                <!-- <v-btn x-small class="px-2 ml-1 ma-1" color="green" outlined @click="assignEnquiryID(item)">
                  Assign Plan
                </v-btn> -->

                <router-link :to="{ name: 'EditRegistration', params: { enquiryID: item.enquiryID, enquiryCode: item.enquiry.enquiryCode, registrationCode: item.registrationCode } }">
                  <v-btn class="px-2 ml-1  ma-1" x-small outlined color="blue">
                    Edit
                  </v-btn>
                </router-link>

                <!-- <v-btn class="px-2 ml-1  ma-1" x-small color="warning" outlined @click="toggleSectionModal(item.enquiryID, item.enquiry.classID, item.enquiry.enquiryCode)">
                  Send Link
                </v-btn> -->

                <!-- <v-btn v-if="modules.OfflinePay" class="px-2 ml-1  ma-1" x-small color="pink" outlined @click.prevent="toggleSectionModalOffline(item.enquiryID, item.enquiry.classID, item.enquiry.enquiryCode)">
                  Offline Pay
                </v-btn> -->
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </material-card>
    </v-container>
    <!-- View Document model -->
    <div class="modal" :class="{ 'is-active': enableDocumentModal }">
      <div class="modal-background"></div>

      <form class="modal-card" style="width:70rem; margin-top:-15rem; height:auto  " @submit.prevent="ShowDocuments()">
        <header class="modal-card-head" style="margin-top:90px;">
          <p class="modal-card-title"><strong>View Documents</strong></p>
          <button class="delete" type="button" @click="this.toggleDocumentModal"></button>
        </header>
        <section class="modal-card-body" style=" overflow: unset;">
          <div class="columns is-centered">
            <div class="columns is-multiline">
              <div class="column is-4" v-if="this.studentPhotoURL">
                <div class="field">
                  <div class="tags">
                    <u class="box"><i class="mdi mdi-file is-medium" @click="downloadFile(studentPhotoURL)" style="cursor:pointer;">Student Photo</i></u> &nbsp;
                  </div>
                </div>
              </div>
              <div class="column is-4" v-if="this.fatherPhotoURL">
                <div class="field">
                  <div class="tags">
                    <u class="box"><i class="mdi mdi-file is-medium" @click="downloadFile(fatherPhotoURL)" style="cursor:pointer;">Parent Photo</i></u> &nbsp;
                  </div>
                </div>
              </div>
              <div class="column is-4" v-if="this.motherPhotoURL">
                <div class="field">
                  <div class="tags">
                    <u class="box"><i class="mdi mdi-file is-medium" @click="downloadFile(motherPhotoURL)" style="cursor:pointer;">Mother Photo</i></u> &nbsp;
                  </div>
                </div>
              </div>
              <div class="column is-4" v-if="birthCertificateURL">
                <div class="field">
                  <div class="tags">
                    <u class="box"><i class="mdi mdi-file is-medium" @click="downloadFile(birthCertificateURL)" style="cursor:pointer;">Birth Certificate</i></u> &nbsp;
                  </div>
                </div>
              </div>
              <div class="column is-4" v-if="this.transferCertificateURL">
                <div class="field">
                  <div class="tags">
                    <u class="box"><i class="mdi mdi-file is-medium" @click="downloadFile(transferCertificateURL)" style="cursor:pointer;">Transfer Certificate</i></u> &nbsp;
                  </div>
                </div>
              </div>
              <div class="column is-4" v-if="this.immunisationCertificateURL">
                <div class="field">
                  <div class="tags">
                    <u class="box"><i class="mdi mdi-file is-medium" @click="downloadFile(immunisationCertificateURL)" style="cursor:pointer;">Immunisation Certificate</i></u> &nbsp;
                  </div>
                </div>
              </div>

              <div class="column is-4" v-if="this.studentAadharCardURL">
                <div class="field">
                  <div class="tags">
                    <u class="box"><i class="mdi mdi-file is-medium" @click="downloadFile(studentAadharCardURL)" style="cursor:pointer;">Student Aadhar card</i></u> &nbsp;
                  </div>
                </div>
              </div>
              <div class="column is-4" v-if="this.fatherAadharCardURL">
                <div class="field">
                  <div class="tags">
                    <u class="box"><i class="mdi mdi-file is-medium" @click="downloadFile(fatherAadharCardURL)" style="cursor:pointer;">Parent Aadhar card</i></u>
                  </div>
                </div>
              </div>
              <div class="column is-4" v-if="this.motherAadharCardURL">
                <div class="field">
                  <div class="tags">
                    <u class="box"><i class="mdi mdi-file is-medium" @click="downloadFile(motherAadharCardURL)" style="cursor:pointer;">Mother Aadhar card</i></u>
                  </div>
                </div>
              </div>
              <div class="column is-4" v-if="this.healthCertificateURL">
                <div class="field">
                  <div class="tags">
                    <u class="box"><i class="mdi mdi-file is-medium" @click="downloadFile(healthCertificateURL)" style="cursor:pointer;">Health Certificate</i></u> &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>

    <!-- Select section model -->
    <!-- <div class="modal" :class="{ 'is-active': enableSectionModal }">
      <div class="modal-background"></div>

      <form class="modal-card" style="width:30rem; margin-top:-15rem; height:auto" @submit.prevent="sendAdmissionLink()">
        <header class="modal-card-head" style="margin-top:90px;">
          <p class="modal-card-title"><strong>Select section</strong></p>
          <button class="delete" type="button" @click="this.toggleSectionModal"></button>
        </header>
        <section class="modal-card-body" style=" overflow: unset;">
          <div class="columns is-centered">
            <div class="column is-6">
              <div class="field">
                <label class="label">Opting Class <span class="has-text-danger">*</span></label>
                <div class="control">
                  <span class="is-fullwidth">
                    <input type="text" v-model="selectedclassName" readonly disabled />
                    <input type="hidden" v-model="selectedclassID" readonly disabled />
                  </span>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Section <span class="has-text-danger">*</span></label>
                <div class="control">
                  <span class="select is-fullwidth">
                    <select class="form-control" v-model="sectionID" required>
                      <option value="">-Select-</option>
                      <option v-for="section in sections" :key="section.id" :value="section.id"> {{ section.name }}</option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <footer class="column has-text-right">
            <button class="button is-success" type="submit" :disabled="hasClicked">
              Send Admission Form Link to Parent

            </button>
          </footer>
        </section>
      </form>
    </div> -->

    <!-- Select section model -->
    <div class="modal" :class="{ 'is-active': enableSectionModalOffline }">
      <div class="modal-background"></div>

      <form class="modal-card" style="width:30rem; margin-top:-15rem; height:auto" @submit.prevent="sendAdmissionLink(true)">
        <header class="modal-card-head" style="margin-top:90px;">
          <p class="modal-card-title"><strong>Select section</strong></p>
          <button class="delete" type="button" @click="this.toggleSectionModalOffline"></button>
        </header>
        <section class="modal-card-body" style=" overflow: unset;">
          <div class="columns is-centered">
            <div class="column is-6">
              <div class="field">
                <label class="label">Opting Class <span class="has-text-danger">*</span></label>
                <div class="control">
                  <span class="is-fullwidth">
                    <input type="text" v-model="selectedclassName" readonly disabled />
                    <input type="hidden" v-model="selectedclassID" readonly disabled />
                  </span>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Section <span class="has-text-danger">*</span></label>
                <div class="control">
                  <span class="select is-fullwidth">
                    <select class="form-control" v-model="sectionID" required>
                      <option value="">-Select-</option>
                      <option v-for="section in sections" :key="section.id" :value="section.id"> {{ section.name }}</option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <footer class="column has-text-right">
            <button class="button is-success" type="submit" :disabled="hasClicked">
              Pay Now
            </button>
          </footer>
        </section>
      </form>
    </div>
    <loading-icon :value="isLoading" />
  </div>
</template>
<script>
import constants from '@/utils/constants'
import Utils from '@/utils'
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import AssignFeePlan from '../../Fees/FeeComponent/assignFeePlan'

export default {
  name: 'registration',
  props: ['radio2'],
  components: {
    AssignFeePlan,
    MaterialCard
  },
  data () {
    return {
      modules: {
        OfflinePay: this.checkModuleAccess('OfflinePay')
      },
      STUDENT_DATA: {},
      search: '',
      headers: [
        { text: 'Student Name', sortable: true, value: 'enquiry.studentFirstName' },
        { text: 'Enquiry Code', value: 'enquiry.enquiryCode', sortable: true },
        { text: 'Application Code', value: 'enquiry.applicationCode', sortable: true },
        { text: 'Registration Code', value: 'registrationCode', sortable: true },
        { text: 'Class', value: 'enquiry.studentClass.name', sortable: true },
        { text: 'Franchisee', value: 'enquiry.franchisee.companyName', sortable: true },
        { text: 'Email', value: 'enquiry.fatherEmailID', sortable: true },
        { text: 'Action', value: 'actions', align: 'center' }
      ],
      planAssignModal: false,
      sendLinkDialogOffline: false,
      enquiryIDD: '',
      isWrite: false,
      filterData: [],
      searchTerm: '',
      radio: 'all',
      total: 0,
      sendLinkDialog: false,
      isLoading: false,
      loadingComponent: null,
      enableDocumentModal: false,
      enableSectionModal: false,
      enableSectionModalOffline: false,
      enquiryData: [],
      franchiseeID: '',
      hasClicked: false,
      sectionID: '',
      classID: '',
      selectedclassID: '',
      selectedclassName: '',
      selectedEnquiryCode: '',
      academicYearID: '',
      isCompo: null,
      findEnquiry: {
        academicYearID: '',
        searchType: 'mobileNo',
        searchKey: ''
      },

      filter: {
        fromDate: moment()
          .subtract(1, 'month')
          .format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        academicYearID: '',
        stage: 'All'
      },
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      stages: [],
      searchEnquiryObj: {
        academicYearID: '',
        searchType: 'studentmobile',
        searchKey: ''
      },
      studentPhotoURL: '',
      fatherPhotoURL: '',
      motherPhotoURL: '',
      birthCertificateURL: '',
      transferCertificateURL: '',
      immunisationCertificateURL: '',
      studentAadharCardURL: '',
      fatherAadharCardURL: '',
      motherAadharCardURL: '',
      healthCertificateURL: '',
      isDataLoaded: false,
      documentData: [],
      registrationData: [],
      classes: [],
      sections: []
    }
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
      await this.academics()
      await this.getRegistration()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
      await this.academics()
      await this.getRegistration()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
      await this.academics()
      await this.getRegistration()
    },
    sendLinkDialog: function (val) {
      if (val === false) {
        this.sectionID = ''
      }
    },
    sendLinkDialogOffline: function (val) {
      if (val === false) {
        this.sectionID = ''
      }
    }
  },
  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    try {
      this.loadingComponent = this.$buefy.loading.open()
      const { data: questions } = await http.get(`${constants.API_URL}/api/enquiry-questions`)
      this.stages = questions.filter(obj => obj.type === 'INTEREST_TYPE')
      const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
      this.academicYears = data.rows
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find(y => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.academicYearID = academicYear ? academicYear.id : ''
      this.loadingComponent.close()
      //   await this.getRegistration()
      this.onFranchiseeChange()
      const studentclasses = await http.get(`${constants.API_URL}/api/students/class`)
      this.classes = studentclasses.data.rows
    } catch (e) {
      this.loadingComponent.close()
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }

    if (this.radio2) {
      this.radio = this.radio2
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    assignEnquiryID: function (enquiryIDs) {
      this.isCompo = ''
      this.$nextTick(() => {
        this.isCompo = AssignFeePlan
      })

      this.enquiryIDD = enquiryIDs.enquiry.id
      this.STUDENT_DATA = enquiryIDs
    },

    generateCSVData: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        let response = await http.post(`${constants.API_URL}/api/download-registrationdatacsv/`, {
          franchiseeID: this.franchiseeID,
          academicYearID: this.academicYear ? this.academicYear.id : this.academicYearID,
          fromDate: this.filter.fromDate,
          toDate: this.filter.toDate
        })

        /** * download file */
        if (!_.isEmpty(response)) {
          const getCSVFileUrl = response.data.url
          await this.downloadCSVDataFile(getCSVFileUrl)
        }
        /** ***** */
        this.loadingComponent.close()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        console.log('error in fetching records : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'NOOOOOOO',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
    },
    onChangeClass: async function () {
      if (!this.inProgress) {
        this.inProgress = true
      }
    },
    downloadCSVDataFile: async function (urlObj) {
      try {
        window.open(urlObj, '_blank')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        console.log('error in fetching records : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    viewDocuments: async function (enquiryCode) {
      this.toggleDocumentModal()
      let response = await http.get(`${constants.API_URL}/api/registration-details/${enquiryCode}`)
      this.registrationData = response.data
      if (!_.isEmpty(this.registrationData.enquiryRegistrations)) {
        this.documentData = this.registrationData.enquiryRegistrations[0]
      }

      this.studentPhotoURL = !_.isEmpty(this.documentData.studentPhotoUrl) && this.documentData.studentPhotoUrl !== '0' ? this.documentData.studentPhotoUrl : ''
      this.fatherPhotoURL = !_.isEmpty(this.documentData.fatherPhotoUrl) && this.documentData.fatherPhotoUrl !== '0' ? this.documentData.fatherPhotoUrl : ''
      this.motherPhotoURL = !_.isEmpty(this.documentData.motherPhotoUrl) && this.documentData.motherPhotoUrl !== '0' ? this.documentData.motherPhotoUrl : ''
      this.birthCertificateURL = !_.isEmpty(this.documentData.birthCertificateUrl) && this.documentData.birthCertificateUrl !== '0' ? this.documentData.birthCertificateUrl : ''
      this.transferCertificateURL = !_.isEmpty(this.documentData.transferCertificateUrl) && this.documentData.transferCertificateUrl !== '0' ? this.documentData.transferCertificateUrl : ''
      this.immunisationCertificateURL =
        !_.isEmpty(this.documentData.immunisationCertificateUrl) && this.documentData.immunisationCertificateUrl !== '0' ? this.documentData.immunisationCertificateUrl : ''
      this.studentAadharCardURL = !_.isEmpty(this.documentData.studentAadharCardUrl) && this.documentData.studentAadharCardUrl !== '0' ? this.documentData.studentAadharCardUrl : ''
      this.fatherAadharCardURL = !_.isEmpty(this.documentData.fatherAadharCardUrl) && this.documentData.fatherAadharCardUrl !== '0' ? this.documentData.fatherAadharCardUrl : ''
      this.motherAadharCardURL = !_.isEmpty(this.documentData.motherAadharCardUrl) && this.documentData.motherAadharCardUrl !== '0' ? this.documentData.motherAadharCardUrl : ''
      this.healthCertificateURL = !_.isEmpty(this.documentData.healthCertificateUrl) && this.documentData.healthCertificateUrl !== '0' ? this.documentData.healthCertificateUrl : ''
    },

    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getRegistration: async function () {
      try {
        if (this.franchiseeID && this.academicYear) {
          const response = await http.post(`${constants.API_URL}/api/registrationlist/`, {
            franchiseeID: this.franchiseeID,
            academicYearID: this.academicYear ? this.academicYear.id : this.academicYearID,
            fromDate: this.filter.fromDate,
            toDate: this.filter.toDate
          })
          this.enquiryData = response.data.rows
          this.searchTerm = null
          this.total = this.enquiryData.length

          this.loadingComponent.close()
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getYearIn: function () {
      this.academicYears.find(obj => {
        if (obj.id === this.filter.academicYearID) {
          this.Year = Number(obj.academicYear.split('-')[0])
        }
      })
    },
    toggleDocumentModal: function () {
      this.enableDocumentModal = !this.enableDocumentModal
    },
    toggleSectionModalOffline: async function (enquiryID, classID, enquiryCode) {
      this.sendLinkDialogOffline = true
      const result = await http.get(`${constants.API_URL}/api/students/section/${classID}`)
      this.sections = result.data
      let sectionArr = this.sections
      this.selectedclassName = sectionArr.name
      if (!_.isEmpty(sectionArr)) {
        this.sections = sectionArr.studentSections
      }
      this.selectedclassID = classID
      this.selectedEnquiryCode = enquiryCode
      this.inProgress = false
    },
    toggleSectionModal: async function (enquiryID, classID, enquiryCode) {
      this.sendLinkDialog = true
      const result = await http.get(`${constants.API_URL}/api/students/section/${classID}`)
      this.sections = result.data
      let sectionArr = this.sections
      this.selectedclassName = sectionArr.name
      if (!_.isEmpty(sectionArr)) {
        this.sections = sectionArr.studentSections
      }
      this.selectedclassID = classID
      this.selectedEnquiryCode = enquiryCode
      this.inProgress = false
    },
    resetAll: function () {
      this.filter = {
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        stage: 'All'
      }
      this.getRegistration()
    },
    academics: async function () {
      const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
      this.academicYears = data.rows
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find(y => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.academicYearID = academicYear ? academicYear.id : ''
    },
    ShowDocuments: async function () {},
    downloadFile: async function (key) {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        await http
          .get(`${constants.API_URL}/api/ticket/downloadurl?s3urlKey=${key}`)
          .then(response => {
            window.open(response.data, '_blank')
          })
          .catch(httpException => {
            return Utils.notify(httpException.message, 'error')
          })

        this.loadingComponent.close()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        console.log('error in fetching User : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getS3Url: async function (key) {
      await http
        .get(`${constants.API_URL}/api/ticket/downloadurl?s3urlKey=${key}`)
        .then(function (response) {
          return response.data
        })
        .catch(httpException => {
          return Utils.notify(httpException.message, 'error')
        })
    },
    sendRegistrationFormLinkToParent: async function (enqID) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.lock = true

        const formData = {
          enquiryID: enqID
        }

        /** * generate Application link */
        await http.post(`${constants.API_URL}/api/generateRegistrationFormLink`, formData)

        this.loadingComponent.close()

        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Email is sent to parent for filling further details !',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    sendAdmissionLink: async function (isOffline = false) {
      try {
        if (!this.sectionID) {
          return this.$dialog.error({
            text: `Select Section`,
            title: 'Error'
          })
        }
        this.loadingComponent = this.$buefy.loading.open()
        this.lock = true

        const formData = {
          enquiryCode: this.selectedEnquiryCode,
          sectionID: this.sectionID,
          mode: isOffline ? 'OFFLINE' : 'ONLINE'
        }

        /** * generate Admission link */
        const response = await http.post(`${constants.API_URL}/api/generateAdmissionFormLink`, formData)
        this.loadingComponent.close()
        if (isOffline) {
          this.sendLinkDialogOffline = false

          // this.$router.push({ name: 'admissionFormOffline', params: { refID: response.data } })

          let route = this.$router.resolve({ name: 'admissionFormOffline', params: { refID: response.data } })
          // let route = this.$router.resolve('/link/to/page'); // This also works.
          window.open(route.href, '_blank')
        } else {
          this.sendLinkDialog = false
          this.sendLinkDialogOffline = false
        }
        this.sendLinkDialog = false
        this.sendLinkDialogOffline = false
        if (!isOffline) {
          return this.$dialog.info({
            text: `Email is sent to parent for filling admission form details !`,
            title: 'Success'
          })
        }
      } catch (e) {
        this.loadingComponent.close()
        this.sendLinkDialog = false
        this.sendLinkDialogOffline = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: `${errorMessage}`,
          title: 'Error'
        })
      }
    }
  }
}
</script>
